































import { defineProps, withDefaults } from "@vue/runtime-dom";
import { computed } from "@vue/composition-api";
import router from "@/router";
import InlineSvg from "vue-inline-svg";
interface Props {
  modal: boolean;
}
const __sfc_main = {};
__sfc_main.props = {
  modal: {
    key: "modal",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const imageDate = require("@/assets/Competition/Raffle/main-content/date.svg");
  const hasDashboard = computed(() => router.currentRoute.name === "dashboard");
  return {
    imageDate,
    hasDashboard
  };
};
__sfc_main.components = Object.assign({
  InlineSvg
}, __sfc_main.components);
export default __sfc_main;
